<template>
    <notification v-if="holderNotification" @destroy="destroyNotification"
                  :message="holderNotification.message" :confirm="holderNotification.confirm" :type="holderNotification.type"></notification>
</template>

<script>
    import notification from './notification.vue'
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "notification_dispatcher",
        components: {
            notification,
        },
        data: () => ({
            holderNotification: null,
        }),
        mounted(){
            this.refresh();
        },
        watch:{
            haveNotification(){
                this.refresh();
            }
        },
        computed: {
            ...mapGetters('notifications',['haveNotification']),
        },
        methods: {
            refresh(){
                if(this.holderNotification === null)
                    this.getNotification();
            },
            getNotification() {
                if (this.haveNotification) {
                    this.pullNotification().then((notification) => {
                        if (notification.message){
                            this.holderNotification = notification;
                        }
                    })
                }

            },
            destroyNotification(){
                this.holderNotification = null;
                setTimeout(()=>{
                    this.getNotification();
                }, 1000)
            },
            ...mapActions('notifications',['pullNotification'])
        }
    }
</script>

<style scoped>

</style>